import { strCode } from "../localizations/strCode";

export const userSegmentIds = {
  regular: "regular",
  chilled: "chilled",
  sprint: "sprint",
  mild: "mild",
  alert: "alert"
};

export const notConnectedUserSegmentIds = {
  triedButFailed: "triedButFailed",
  neverTried: "neverTried"
};

export const userSegments = [
  { id: userSegmentIds.regular, value: strCode.REGULAR_SEGMENT_TITLE, connected: true },
  { id: userSegmentIds.chilled, value: strCode.CHILLED_SEGMENT_TITLE, connected: true },
  { id: userSegmentIds.sprint, value: strCode.SPRINT_SEGMENT_TITLE, connected: true },
  { id: userSegmentIds.mild, value: strCode.MILD_SEGMENT_TITLE, connected: true },
  { id: userSegmentIds.alert, value: strCode.ALERT_SEGMENT_TITLE, connected: true },
  {
    id: notConnectedUserSegmentIds.triedButFailed,
    value: strCode.TRIED_BUT_FAILED_SEGMENT_TITLE,
    connected: false
  },
  {
    id: notConnectedUserSegmentIds.neverTried,
    value: strCode.NEVER_TRIED_SEGMENT_TITLE,
    connected: false
  }
];
